import './LoginForm.css'
import { useState } from 'react';
import { login } from '../../utilities/services/clients'
import { useNavigate } from 'react-router-dom';

const defaultState = {
    clientNumber: '',
    email: '',
    password: '',
    error: ''
}

export default function LoginForm({ updateClient }) {
    const [formData, setFormData] = useState(defaultState)
    const navigate = useNavigate()

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        const data = {
            clientID: formData.clientNumber,
            email: formData.email,
            password: formData.password
        }
        try {
            const client = await login(data)
            updateClient(client)
            navigate('/')
            window.location.reload();
            // redirectEndpoint ? navigate(`/${redirectEndpoint}`) : navigate('/')
        } catch (err) {
            setFormData({
                ...formData,
                // error: 'Log in Failed - Try again!'
                error: err.message
            })
        }
    }

    function handleChange(evt) {
        const newFormData = {
            ...formData,
            [evt.target.name]: evt.target.value,
            error: ''
        };
        setFormData(newFormData);
    }

    const disabled = !formData.email || !formData.password

    return (
        <div className='LoginForm'>
            <div className="formContainer">
                <div className='headerImage'><img src="https://project-intake-assets.s3.ca-central-1.amazonaws.com/Logo.svg" alt="Not Found"/></div>
                <div className="headerText1">Client Portal</div>
                <p className="headerText2 tertiaryText">Welcome back! Please enter your details.</p>
                <form onSubmit={handleSubmit} autoComplete="off" id='loginForm'>
                    <div className='inputContainer'>
                        <div className='mb-3'>
                            <label htmlFor="clientNumber" className='form-label'>Client No:</label>
                            <input className='form-control shadow-none clientID' type="text" name="clientNumber" id="clientNumber" placeholder='Enter Client No' value={formData.clientNumber} onChange={handleChange} required autoComplete="off" />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="email" className='form-label'>User ID:</label>
                            <input className='form-control shadow-none email' type="text" name="email" id="email" placeholder='Enter User ID' value={formData.email} onChange={handleChange} required autoComplete="off" />
                        </div>
                        <div className='mb-3'>
                            <label htmlFor="password" className='form-label'>Password:</label>
                            <input className='form-control shadow-none password' type="password" name="password" id="password" placeholder='Enter Password' value={formData.password} onChange={handleChange} required autoComplete="off" />
                        </div>
                    </div>
                    <button className='submitButton' type="submit" disabled={disabled}>Log In</button>
                </form>
            </div>
            {formData.error && <p className="errorText">&nbsp;{formData.error}</p>}
            <footer className='footer secondaryText'>
                <p className='tertiaryText'>© Client Portal 2025</p>
            </footer>
        </div>
    )
}